import { type FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Task } from '@repo/shared';

import { useDatasetOptions } from '@/api/generated';
import Combobox, { type ComboboxProps } from '@/components/ui/combobox';
import { Skeleton } from '@/components/ui/skeleton';

interface DatasetComboboxProps extends Omit<ComboboxProps<false>, 'options'> {
  task?: Task;
}

const DatasetCombobox: FC<DatasetComboboxProps> = ({ task, ...props }) => {
  const { t } = useTranslation();

  const { data: datasets, isLoading } = useDatasetOptions({ task });
  const options = useMemo(
    () =>
      datasets?.map((dataset) => ({
        label: dataset.name,
        value: dataset.id,
      })) ?? [],
    [datasets]
  );

  if (isLoading) {
    return <Skeleton className='h-10 w-full' />;
  }

  return (
    <Combobox
      {...props}
      placeholder={t('components.datasetCombobox.placeholder')}
      options={options}
    />
  );
};

export default DatasetCombobox;
